/**
 * @file: InspectionTaskEventType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum InspectionTaskEventType {
  System = 0,
  Creation = 100,
  Inspection = 200,
  Quotation = 300,
  Construction = 400,
  Completion = 600,
  PreInspection = 700,
  DeliveryCheck = 800,
  SamplingCheck = 900,
}

export const InspectionTaskEventTypeValueSet = new Set([
  InspectionTaskEventType.System,
  InspectionTaskEventType.Creation,
  InspectionTaskEventType.Inspection,
  InspectionTaskEventType.Quotation,
  InspectionTaskEventType.Construction,
  InspectionTaskEventType.Completion,
  InspectionTaskEventType.PreInspection,
  InspectionTaskEventType.DeliveryCheck,
  InspectionTaskEventType.SamplingCheck,
]);
